import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { useResolve } from '../../Container';
import { Participant } from './Participant';
import { ParticipantManager } from './ParticipantManager';

export const useParticipant = (userId: string) => {
    return useObserver(useResolve(ParticipantManager).getOrFallback(userId));
};

export const useParticipant2 = (userId: string) => {
    const ptpts = useResolve(ParticipantManager);
    if (!userId) return Participant.unknown;
    return ptpts.getOrLoad(userId);
};
